import React, { Component } from "react";
import { connect } from "react-redux";

import { Switch, Route } from "react-router-dom";
import {
  showBackButton,
  getUserForAuth,
  logoutUser,
} from "../../../actions/authAction";

import PropResiCreate from "./PropResiCreate";

import PropResiDetail from "./PropResiDetail";

import PropResiSaleSearchList from "./PropResiSaleSearchList";

import PropResiRentSearchList from "./PropResiRentSearchList";

class PropResiDashboard extends Component {
  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.getUserForAuth();
    }
    if (this.props.history.location.pathname !== "/") {
      this.props.showBackButton();
    }
  }
  onLogoutClick = () => {
    this.props.logoutUser();
  };
  render() {
    return (
      <div className="font-family-Roboto">
        <div style={{}} className="maindiv bgColor-gr1">
          <Switch>
            <Route
              exact
              path="/ggn/propresi/PropResiCreate"
              component={PropResiCreate}
            />
            <Route
              exact
              path="/ggn/propresi/PropResiDetail/:id"
              component={PropResiDetail}
            />

            <Route
              exact
              path="/ggn/propresi/PropResiSaleSearchList"
              component={PropResiSaleSearchList}
            />
            <Route
              exact
              path="/ggn/propresi/PropResiRentSearchList"
              component={PropResiRentSearchList}
            />
          </Switch>
        </div>

        {/* <div >
    <ScrollBottomButton scrollStepInPx="11550" delayInMs="16.66"/>

  <ScrollTopButton scrollStepInPx="11000" delayInMs="16.66"/>
</div> */}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  state,
});

export default connect(
  mapStateToProps,

  {
    showBackButton,
    getUserForAuth,
    logoutUser,
  }
)(PropResiDashboard);
